import { render } from "./department-list.vue?vue&type=template&id=5fddf7f7"
import script from "./department-list.vue?vue&type=script&setup=true&lang=js"
export * from "./department-list.vue?vue&type=script&setup=true&lang=js"

import "./department-list.vue?vue&type=style&index=0&id=5fddf7f7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/app-depart-layout/components/department-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fddf7f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fddf7f7', __exports__)) {
    api.reload('5fddf7f7', __exports__)
  }
  
  module.hot.accept("./department-list.vue?vue&type=template&id=5fddf7f7", () => {
    api.rerender('5fddf7f7', render)
  })

}


export default __exports__